"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsLogic = void 0;
const courseDataHelpers_1 = require("../Utils/courseDataHelpers");
const stablefordUtils_1 = require("./stablefordUtils");
const seriesPointsUtils_1 = require("./seriesPointsUtils");
const seriesPointsDebug_1 = require("./seriesPointsDebug");
const TeamsSumScores = ({ leaderboardData, courseData, currentRound, setLocalTeamsData, leaderboardScoreFormat, eventData }) => {
    /* console.log('Ordering  data. I have leaderboardData of:', leaderboardData.length);
    console.log('Leaderboard data:', leaderboardData);
    console.log('Course data:', courseData); */
    let totalScoreToPar = 0;
    let totalPoints = 0;
    let holesCompleted = 18;
    let eventScores = [];
    let confirmed = true;
    let submitted = true;
    const countingScores = Number(eventData?.countingScores) || null;
    const roundPlayType = eventData?.rounds?.[currentRound - 1]?.playType;
    const stableford = (0, stablefordUtils_1.isStablefordPlayType)(roundPlayType);
    const holePoints = eventData?.rounds?.[currentRound - 1]?.holePoints ?? [];
    const isNet = leaderboardScoreFormat === 'net';
    const processedTeamsData = leaderboardData.sort((a, b) => {
        // Convert teamName to string and handle null/undefined values
        const teamNameA = String(a.teamName || '');
        const teamNameB = String(b.teamName || '');
        return teamNameA.localeCompare(teamNameB);
    }).map((item, index) => {
        totalScoreToPar = 0;
        totalPoints = 0;
        holesCompleted = 18;
        eventScores = [];
        confirmed = true;
        submitted = true;
        // Get the courseID for the current round
        const roundCourseID = eventData?.rounds?.[currentRound - 1]?.courseID;
        const currentCourseData = (0, courseDataHelpers_1.getCourseById)(courseData, roundCourseID);
        const teeSetData = (0, courseDataHelpers_1.getTeeSetFromCourse)(currentCourseData, item?.playerInfo?.[0]?.teeSet);
        (item?.roundScores?.[currentRound - 1]?.holeScores ?? []).forEach((holeScore) => {
            if (holeScore.playerScore !== 0 && holeScore.playerScore !== null) {
                totalScoreToPar += holeScore.playerScore - (leaderboardScoreFormat === 'net' ? holeScore.playerHcpAdj : 0) - (teeSetData?.holes?.[holeScore.holeNumber - 1]?.par || 0);
                if (stableford) {
                    totalPoints += (0, stablefordUtils_1.calculateHoleStablefordPoints)(holeScore.playerScore, holeScore.par, holeScore.playerHcpAdj ?? 0, isNet, holePoints);
                }
            }
        });
        confirmed = item?.roundScores?.[currentRound - 1]?.confirmed ?
            (confirmed ? true : false) : false;
        submitted = item?.roundScores?.[currentRound - 1]?.submitted ?
            (submitted ? true : false) : false;
        holesCompleted = Math.min(holesCompleted, item.holesCompleted);
        eventScores.push(item);
        return {
            _id: item._id,
            teamName: item.teamName,
            toPar: totalScoreToPar,
            totalPoints: stableford ? totalPoints : undefined,
            eventScores: eventScores,
            holesCompleted: holesCompleted,
            confirmed: confirmed,
            submitted: submitted
        };
    }).filter((item) => item !== undefined); // Ensure item is not undefined
    const teamNames = Array.from(new Set(processedTeamsData.map((item) => item.teamName)));
    const reducedTeamsData = teamNames.map((item, index) => {
        const filteredData = processedTeamsData.filter((pItem) => pItem.teamName === item);
        const sortedFiltered = stableford
            ? filteredData.sort((a, b) => (b.totalPoints ?? 0) - (a.totalPoints ?? 0))
            : filteredData.sort((a, b) => a.toPar - b.toPar);
        const slicedData = sortedFiltered.slice(0, countingScores || sortedFiltered.length);
        return {
            _id: filteredData[0]._id,
            teamName: filteredData[0].teamName,
            toPar: stableford ? undefined : slicedData.reduce((acc, curr) => acc + curr.toPar, 0),
            totalPoints: stableford ? slicedData.reduce((acc, curr) => acc + (curr.totalPoints ?? 0), 0) : undefined,
            eventScores: filteredData.flatMap((item) => item.eventScores),
            holesCompleted: Math.min(...filteredData.map((f) => f.holesCompleted)),
            confirmed: filteredData.every((f) => f.confirmed),
            submitted: filteredData.every((f) => f.submitted)
        };
    });
    //console.log('Reduced Teams Data:', reducedTeamsData);
    const cleanedTeamsData = reducedTeamsData.filter((item) => (item.teamName && item.teamName !== "") &&
        (item.eventScores && item.eventScores.length > 1));
    const adminRanks = Array.from(new Set(cleanedTeamsData.filter((item) => item.eventScores.some((score) => score.teamRank && score.teamRank > 0)).map((item) => item.eventScores.find((score) => score.teamRank && score.teamRank > 0).teamRank)));
    const sortedTeamsData = cleanedTeamsData
        .sort((a, b) => {
        // First, handle the case where one or both players have 0 holes completed
        if (a.holesCompleted === 0 && b.holesCompleted === 0) {
            return 0; // Both have 0 holes, keep original order
        }
        if (a.holesCompleted === 0) {
            return 1; // a has 0 holes, b has some - a goes after b
        }
        if (b.holesCompleted === 0) {
            return -1; // b has 0 holes, a has some - b goes after a
        }
        // Sort by score: Stableford = higher points better, stroke = lower toPar better
        if (stableford) {
            const aPts = a.totalPoints ?? -Infinity;
            const bPts = b.totalPoints ?? -Infinity;
            if (aPts !== bPts)
                return bPts - aPts;
        }
        else {
            if (a.toPar !== b.toPar)
                return a.toPar - b.toPar;
        }
        return b.holesCompleted - a.holesCompleted;
    })
        .reduce((acc, item, index, array) => {
        const maxExistingRank = index === 0 ?
            Math.max(...cleanedTeamsData.map((entry) => entry.teamRank || 0)) :
            acc.length > 0 ? Math.max(...acc.map((entry) => entry.teamRank || 0)) : 0;
        const existingTeamRank = item.eventScores?.find((score) => score.teamRank && score.teamRank > 0)?.teamRank;
        let calculatedRank;
        let calcRankComment;
        if (existingTeamRank && existingTeamRank > 0) {
            calculatedRank = existingTeamRank;
            calcRankComment = 'Keep existing rank';
        }
        else if (index > 0 &&
            ((item.holesCompleted > 0 && array[index - 1].holesCompleted > 0 &&
                (stableford
                    ? (item.totalPoints ?? -Infinity) === (array[index - 1].totalPoints ?? -Infinity)
                    : item.toPar === array[index - 1].toPar)) ||
                (item.holesCompleted === 0 && array[index - 1].holesCompleted === 0))) {
            calculatedRank = acc[acc.length - 1].teamRank;
            calcRankComment = 'Same rank for ties';
        }
        else {
            if (index + 1 < Math.min(...adminRanks)) {
                calculatedRank = index + 1;
            }
            else {
                calculatedRank = Math.max(maxExistingRank + 1, index + 1, adminRanks.length > 0 ? Math.max(...adminRanks) + 1 : 1);
            }
            calcRankComment = 'New rank after max existing rank';
        }
        item.teamRank = calculatedRank;
        acc.push(item);
        return acc;
    }, [])
        .sort((a, b) => {
        if (a.teamRank !== b.teamRank) {
            return a.teamRank - b.teamRank;
        }
        return b.holesCompleted - a.holesCompleted;
    });
    setLocalTeamsData(sortedTeamsData);
};
const TeamsWorstScoresByHole = ({ leaderboardData, courseData, currentRound, setLocalTeamsData, leaderboardScoreFormat, eventData }) => {
    let totalScoreToPar = Array(18).fill(-5);
    let totalPointsByHole = Array(18).fill(0);
    let holesCompleted = 18;
    let eventScores = [];
    let confirmed = true;
    let submitted = true;
    const roundPlayType = eventData?.rounds?.[currentRound - 1]?.playType;
    const stableford = (0, stablefordUtils_1.isStablefordPlayType)(roundPlayType);
    const holePoints = eventData?.rounds?.[currentRound - 1]?.holePoints ?? [];
    const isNet = leaderboardScoreFormat === 'net';
    const processedTeamsData = leaderboardData.sort((a, b) => {
        const teamNameA = String(a.teamName || '');
        const teamNameB = String(b.teamName || '');
        return teamNameA.localeCompare(teamNameB);
    }).map((item, index) => {
        if (index > 0 && item.teamName !== leaderboardData[index - 1].teamName) {
            totalScoreToPar = Array(18).fill(-5);
            totalPointsByHole = Array(18).fill(0);
            holesCompleted = 18;
            eventScores = [];
            confirmed = true;
            submitted = true;
        }
        const roundCourseID = eventData?.rounds?.[currentRound - 1]?.courseID;
        const currentCourseData = (0, courseDataHelpers_1.getCourseById)(courseData, roundCourseID);
        const teeSetData = (0, courseDataHelpers_1.getTeeSetFromCourse)(currentCourseData, item?.playerInfo?.[0]?.teeSet);
        (item?.roundScores?.[currentRound - 1]?.holeScores ?? []).forEach((holeScore, holeIdx) => {
            if (holeScore.playerScore !== 0 && holeScore.playerScore !== null) {
                if (stableford) {
                    const pts = (0, stablefordUtils_1.calculateHoleStablefordPoints)(holeScore.playerScore, holeScore.par, holeScore.playerHcpAdj ?? 0, isNet, holePoints);
                    totalPointsByHole[holeIdx] = holeIdx === 0 || totalPointsByHole[holeIdx] === 0
                        ? pts
                        : Math.min(totalPointsByHole[holeIdx], pts);
                }
                else {
                    totalScoreToPar[holeIdx] = Math.max(totalScoreToPar[holeIdx], holeScore.playerScore - (leaderboardScoreFormat === 'net' ? holeScore.playerHcpAdj : 0) - (teeSetData?.holes?.[holeScore.holeNumber - 1]?.par || 0));
                }
            }
            else if (!stableford) {
                totalScoreToPar[holeIdx] = 0;
            }
        });
        confirmed = item?.roundScores?.[currentRound - 1]?.confirmed ? (confirmed ? true : false) : false;
        submitted = item?.roundScores?.[currentRound - 1]?.submitted ? (submitted ? true : false) : false;
        holesCompleted = Math.min(holesCompleted, item.holesCompleted);
        eventScores.push(item);
        if (index === leaderboardData.length - 1 || item.teamName !== leaderboardData[index + 1]?.teamName) {
            const toParVal = stableford ? undefined : totalScoreToPar.reduce((acc, curr) => acc + curr, 0);
            const totalPtsVal = stableford ? totalPointsByHole.reduce((acc, curr) => acc + curr, 0) : undefined;
            return {
                _id: item._id,
                teamName: item.teamName,
                toPar: toParVal,
                totalPoints: totalPtsVal,
                eventScores: eventScores,
                holesCompleted: holesCompleted,
                confirmed: confirmed,
                submitted: submitted
            };
        }
    }).filter((item) => item !== undefined);
    const adminRanks = Array.from(new Set(processedTeamsData.filter((item) => item.eventScores.some((score) => score.teamRank && score.teamRank > 0)).map((item) => item.eventScores.find((score) => score.teamRank && score.teamRank > 0).teamRank)));
    const sortedTeamsData = processedTeamsData
        .sort((a, b) => {
        // First, handle the case where one or both players have 0 holes completed
        if (a.holesCompleted === 0 && b.holesCompleted === 0) {
            return 0; // Both have 0 holes, keep original order
        }
        if (a.holesCompleted === 0) {
            return 1; // a has 0 holes, b has some - a goes after b
        }
        if (b.holesCompleted === 0) {
            return -1; // b has 0 holes, a has some - b goes after a
        }
        // Both players have completed holes, sort by toPar
        if (a.toPar !== b.toPar) {
            return a.toPar - b.toPar; // Lower score is better
        }
        // If toPar is the same, sort by holesCompleted (descending)
        return b.holesCompleted - a.holesCompleted;
    })
        .reduce((acc, item, index, array) => {
        // Find the maximum rank currently assigned in the accumulated array
        const maxExistingRank = index === 0 ?
            Math.max(...processedTeamsData.map((entry) => entry.teamRank || 0)) :
            acc.length > 0 ? Math.max(...acc.map((entry) => entry.teamRank || 0)) : 0;
        const existingTeamRank = item.eventScores?.find((score) => score.teamRank && score.teamRank > 0)?.teamRank;
        // Calculate the new rank based on sorting rules
        let calculatedRank;
        let calcRankComment;
        // If item already has a rank, keep it
        if (existingTeamRank && existingTeamRank > 0) {
            calculatedRank = existingTeamRank;
            calcRankComment = 'Keep existing rank';
        }
        // If item is a tie, keep the same rank
        else if (index > 0 &&
            ((item.holesCompleted > 0 && array[index - 1].holesCompleted > 0 &&
                item.toPar === array[index - 1].toPar /*&&
            item.holesCompleted === array[index - 1].holesCompleted */) ||
                (item.holesCompleted === 0 && array[index - 1].holesCompleted === 0))) {
            calculatedRank = acc[acc.length - 1].teamRank; // Same rank for ties
            calcRankComment = 'Same rank for ties';
        }
        // If item is not a tie, assign a new rank
        else {
            if (index + 1 < Math.min(...adminRanks)) {
                calculatedRank = index + 1;
            }
            else {
                calculatedRank = Math.max(maxExistingRank + 1, index + 1, adminRanks.length > 0 ? Math.max(...adminRanks) + 1 : 1);
            }
            calcRankComment = 'New rank after max existing rank';
        }
        //console.log('Calculated Rank:', calculatedRank, calcRankComment);
        //console.log('Max Existing Rank:', maxExistingRank);
        //console.log('Admin Ranks:', adminRanks);
        item.teamRank = calculatedRank;
        acc.push(item);
        return acc;
    }, [])
        .sort((a, b) => {
        // Sort by rank value first, then by holes completed (descending)
        if (a.teamRank !== b.teamRank) {
            return a.teamRank - b.teamRank;
        }
        return b.holesCompleted - a.holesCompleted;
    });
    //console.log('Sorted Teams Data:', sortedTeamsData);
    setLocalTeamsData(sortedTeamsData);
};
const TeamsBestScoresByHole = ({ leaderboardData, courseData, currentRound, setLocalTeamsData, leaderboardScoreFormat, eventData }) => {
    //console.log('Ordering  data. I have leaderboardData of:', leaderboardData.length);
    //console.log('Leaderboard data:', leaderboardData);
    //console.log('Course data:', courseData);
    let totalScoreToPar = 0;
    let holesCompleted = 18;
    let eventScores = [];
    let confirmed = true;
    let submitted = true;
    let holeScoreBuckets = Array.from({ length: 18 }, () => []);
    const countingScoresRaw = Number(eventData?.countingScores);
    const countingScores = Number.isFinite(countingScoresRaw) && countingScoresRaw > 0
        ? Math.floor(countingScoresRaw)
        : 1;
    const effectiveCountingScores = eventData?.useTeams ? countingScores : 1;
    const processedTeamsData = leaderboardData.sort((a, b) => {
        // Convert teamName to string and handle null/undefined values
        const teamNameA = String(a.teamName || '');
        const teamNameB = String(b.teamName || '');
        return teamNameA.localeCompare(teamNameB);
    }).map((item, index) => {
        //if (index === 0) {console.log('Item:', item);}
        if (index > 0 && item.teamName !== leaderboardData[index - 1].teamName) {
            totalScoreToPar = 0;
            holesCompleted = 18;
            eventScores = [];
            confirmed = true;
            submitted = true;
            holeScoreBuckets = Array.from({ length: 18 }, () => []);
        }
        // Get the courseID for the current round
        const roundCourseID = eventData?.rounds?.[currentRound - 1]?.courseID;
        const currentCourseData = (0, courseDataHelpers_1.getCourseById)(courseData, roundCourseID);
        const teeSetData = (0, courseDataHelpers_1.getTeeSetFromCourse)(currentCourseData, item?.playerInfo?.[0]?.teeSet);
        (item?.roundScores?.[currentRound - 1]?.holeScores ?? []).forEach((holeScore, index) => {
            if (holeScore.playerScore !== 0 && holeScore.playerScore !== null) {
                //if (item.teamName === 1) {
                //console.log('Hole:', holeScore.holeNumber);
                //console.log('Par:', teeSetData?.holes?.[holeScore.holeNumber - 1]?.par);
                //console.log('Score:', holeScore.playerScore);
                //console.log('Match.min', totalScoreToPar[index], holeScore.playerScore - (leaderboardScoreFormat === 'net' ? holeScore.playerHcpAdj : 0) - (teeSetData?.holes?.[holeScore.holeNumber - 1]?.par || 0));
                //}
                holeScoreBuckets[index].push(holeScore.playerScore
                    - (leaderboardScoreFormat === 'net' ? holeScore.playerHcpAdj : 0)
                    - (teeSetData?.holes?.[holeScore.holeNumber - 1]?.par || 0));
            }
        });
        //console.log('Confirmed/Submitted:', item?.roundScores?.[currentRound - 1]?.confirmed, item?.roundScores?.[currentRound - 1]?.submitted);
        confirmed = item?.roundScores?.[currentRound - 1]?.confirmed ?
            (confirmed ? true : false) : false;
        submitted = item?.roundScores?.[currentRound - 1]?.submitted ?
            (submitted ? true : false) : false;
        holesCompleted = Math.min(holesCompleted, item.holesCompleted);
        eventScores.push(item);
        if (index === leaderboardData.length - 1 || item.teamName !== leaderboardData[index + 1].teamName) {
            totalScoreToPar = holeScoreBuckets.reduce((teamTotal, holeValues) => {
                if (holeValues.length === 0)
                    return teamTotal;
                const selectedScores = holeValues
                    .slice()
                    .sort((a, b) => a - b)
                    .slice(0, effectiveCountingScores);
                return teamTotal + selectedScores.reduce((sum, value) => sum + value, 0);
            }, 0);
            //console.log(`Total Score To Par: ${item.teamName}:`,
            //totalScoreToPar.reduce((acc: number, curr: number) => acc + curr, 0),totalScoreToPar);
            return {
                _id: item._id,
                teamName: item.teamName,
                toPar: totalScoreToPar,
                eventScores: eventScores,
                holesCompleted: holesCompleted,
                confirmed: confirmed,
                submitted: submitted
            };
        }
    }).filter((item) => item !== undefined); // Ensure item is not undefined
    const adminRanks = Array.from(new Set(processedTeamsData.filter((item) => item.eventScores.some((score) => score.teamRank && score.teamRank > 0)).map((item) => item.eventScores.find((score) => score.teamRank && score.teamRank > 0).teamRank)));
    const sortedTeamsData = processedTeamsData
        .sort((a, b) => {
        // First, handle the case where one or both players have 0 holes completed
        if (a.holesCompleted === 0 && b.holesCompleted === 0) {
            return 0; // Both have 0 holes, keep original order
        }
        if (a.holesCompleted === 0) {
            return 1; // a has 0 holes, b has some - a goes after b
        }
        if (b.holesCompleted === 0) {
            return -1; // b has 0 holes, a has some - b goes after a
        }
        // Both players have completed holes, sort by toPar
        if (a.toPar !== b.toPar) {
            return a.toPar - b.toPar; // Lower score is better
        }
        // If toPar is the same, sort by holesCompleted (descending)
        return b.holesCompleted - a.holesCompleted;
    })
        .reduce((acc, item, index, array) => {
        // Find the maximum rank currently assigned in the accumulated array
        const maxExistingRank = index === 0 ?
            Math.max(...processedTeamsData.map((entry) => entry.teamRank || 0)) :
            acc.length > 0 ? Math.max(...acc.map((entry) => entry.teamRank || 0)) : 0;
        const existingTeamRank = item.eventScores?.find((score) => score.teamRank && score.teamRank > 0)?.teamRank;
        // Calculate the new rank based on sorting rules
        let calculatedRank;
        let calcRankComment;
        // If item already has a rank, keep it
        if (existingTeamRank && existingTeamRank > 0) {
            calculatedRank = existingTeamRank;
            calcRankComment = 'Keep existing rank';
        }
        // If item is a tie, keep the same rank
        else if (index > 0 &&
            ((item.holesCompleted > 0 && array[index - 1].holesCompleted > 0 &&
                item.toPar === array[index - 1].toPar /*&&
            item.holesCompleted === array[index - 1].holesCompleted */) ||
                (item.holesCompleted === 0 && array[index - 1].holesCompleted === 0))) {
            calculatedRank = acc[acc.length - 1].teamRank; // Same rank for ties
            calcRankComment = 'Same rank for ties';
        }
        // If item is not a tie, assign a new rank
        else {
            if (index + 1 < Math.min(...adminRanks)) {
                calculatedRank = index + 1;
            }
            else {
                calculatedRank = Math.max(maxExistingRank + 1, index + 1, adminRanks.length > 0 ? Math.max(...adminRanks) + 1 : 1);
            }
            calcRankComment = 'New rank after max existing rank';
        }
        //console.log('Calculated Rank:', calculatedRank, calcRankComment);
        //console.log('Max Existing Rank:', maxExistingRank);
        //console.log('Admin Ranks:', adminRanks);
        item.teamRank = calculatedRank;
        acc.push(item);
        return acc;
    }, [])
        .sort((a, b) => {
        // Sort by rank value first, then by holes completed (descending)
        if (a.teamRank !== b.teamRank) {
            return a.teamRank - b.teamRank;
        }
        return b.holesCompleted - a.holesCompleted;
    });
    //console.log('Sorted Teams Data:', sortedTeamsData);
    setLocalTeamsData(sortedTeamsData);
};
const TeamsHighLowByHole = ({ leaderboardData, courseData, currentRound, setLocalTeamsData, leaderboardScoreFormat, eventData }) => {
    let totalScoreToPar = 0;
    let holesCompleted = 18;
    let eventScores = [];
    let confirmed = true;
    let submitted = true;
    let holeScoreBuckets = Array.from({ length: 18 }, () => []);
    const processedTeamsData = leaderboardData.sort((a, b) => {
        const teamNameA = String(a.teamName || '');
        const teamNameB = String(b.teamName || '');
        return teamNameA.localeCompare(teamNameB);
    }).map((item, index) => {
        if (index > 0 && item.teamName !== leaderboardData[index - 1].teamName) {
            totalScoreToPar = 0;
            holesCompleted = 18;
            eventScores = [];
            confirmed = true;
            submitted = true;
            holeScoreBuckets = Array.from({ length: 18 }, () => []);
        }
        const roundCourseID = eventData?.rounds?.[currentRound - 1]?.courseID;
        const currentCourseData = (0, courseDataHelpers_1.getCourseById)(courseData, roundCourseID);
        const teeSetData = (0, courseDataHelpers_1.getTeeSetFromCourse)(currentCourseData, item?.playerInfo?.[0]?.teeSet);
        (item?.roundScores?.[currentRound - 1]?.holeScores ?? []).forEach((holeScore, index) => {
            if (holeScore.playerScore !== 0 && holeScore.playerScore !== null) {
                holeScoreBuckets[index].push(holeScore.playerScore
                    - (leaderboardScoreFormat === 'net' ? holeScore.playerHcpAdj : 0)
                    - (teeSetData?.holes?.[holeScore.holeNumber - 1]?.par || 0));
            }
        });
        confirmed = item?.roundScores?.[currentRound - 1]?.confirmed ?
            (confirmed ? true : false) : false;
        submitted = item?.roundScores?.[currentRound - 1]?.submitted ?
            (submitted ? true : false) : false;
        holesCompleted = Math.min(holesCompleted, item.holesCompleted);
        eventScores.push(item);
        if (index === leaderboardData.length - 1 || item.teamName !== leaderboardData[index + 1].teamName) {
            totalScoreToPar = holeScoreBuckets.reduce((teamTotal, holeValues) => {
                if (holeValues.length === 0)
                    return teamTotal;
                if (holeValues.length === 1)
                    return teamTotal + holeValues[0];
                const sortedValues = holeValues.slice().sort((a, b) => a - b);
                return teamTotal + sortedValues[0] + sortedValues[sortedValues.length - 1];
            }, 0);
            return {
                _id: item._id,
                teamName: item.teamName,
                toPar: totalScoreToPar,
                eventScores: eventScores,
                holesCompleted: holesCompleted,
                confirmed: confirmed,
                submitted: submitted
            };
        }
    }).filter((item) => item !== undefined);
    const adminRanks = Array.from(new Set(processedTeamsData.filter((item) => item.eventScores.some((score) => score.teamRank && score.teamRank > 0)).map((item) => item.eventScores.find((score) => score.teamRank && score.teamRank > 0).teamRank)));
    const sortedTeamsData = processedTeamsData
        .sort((a, b) => {
        if (a.holesCompleted === 0 && b.holesCompleted === 0) {
            return 0;
        }
        if (a.holesCompleted === 0) {
            return 1;
        }
        if (b.holesCompleted === 0) {
            return -1;
        }
        if (a.toPar !== b.toPar) {
            return a.toPar - b.toPar;
        }
        return b.holesCompleted - a.holesCompleted;
    })
        .reduce((acc, item, index, array) => {
        const maxExistingRank = index === 0 ?
            Math.max(...processedTeamsData.map((entry) => entry.teamRank || 0)) :
            acc.length > 0 ? Math.max(...acc.map((entry) => entry.teamRank || 0)) : 0;
        const existingTeamRank = item.eventScores?.find((score) => score.teamRank && score.teamRank > 0)?.teamRank;
        let calculatedRank;
        if (existingTeamRank && existingTeamRank > 0) {
            calculatedRank = existingTeamRank;
        }
        else if (index > 0 &&
            ((item.holesCompleted > 0 && array[index - 1].holesCompleted > 0 &&
                item.toPar === array[index - 1].toPar) ||
                (item.holesCompleted === 0 && array[index - 1].holesCompleted === 0))) {
            calculatedRank = acc[acc.length - 1].teamRank;
        }
        else {
            if (index + 1 < Math.min(...adminRanks)) {
                calculatedRank = index + 1;
            }
            else {
                calculatedRank = Math.max(maxExistingRank + 1, index + 1, adminRanks.length > 0 ? Math.max(...adminRanks) + 1 : 1);
            }
        }
        item.teamRank = calculatedRank;
        acc.push(item);
        return acc;
    }, [])
        .sort((a, b) => {
        if (a.teamRank !== b.teamRank) {
            return a.teamRank - b.teamRank;
        }
        return b.holesCompleted - a.holesCompleted;
    });
    setLocalTeamsData(sortedTeamsData);
};
const TeamsBestRound = ({ leaderboardData, courseData, currentRound, setLocalTeamsData, leaderboardScoreFormat, eventData }) => {
    //console.log('Ordering  data. I have leaderboardData of:', leaderboardData.length);
    //console.log('Leaderboard data:', leaderboardData);
    //console.log('Course data:', courseData);
    let totalScoreToPar = 0;
    let holesCompleted = leaderboardData[0].roundScores.reduce((totalHoles, roundScore) => {
        return totalHoles + roundScore.holeScores.length;
    }, 0);
    let eventScores = [];
    let confirmed = true;
    let submitted = true;
    //let bestRoundScore = 0;
    const processedTeamsData = leaderboardData.sort((a, b) => {
        // Convert teamName to string and handle null/undefined values
        const teamNameA = String(a.teamName || '');
        const teamNameB = String(b.teamName || '');
        return teamNameA.localeCompare(teamNameB);
    }).map((item, index) => {
        let playerBestRoundScore = Infinity;
        let hasValidRound = false;
        //if (index === 0) {console.log('Item:', item);}
        if (index > 0 && item.teamName !== leaderboardData[index - 1].teamName) {
            totalScoreToPar = 0;
            holesCompleted = 72;
            eventScores = [];
            confirmed = true;
            submitted = true;
            //bestRoundScore = 100;
        }
        if (item?.playerInfo?.[0]?.playerName.includes('Alex')) {
            // console.log('Current Round:', currentRound);
            // console.log('All Round Scores:', item.roundScores.map((r: any) => ({ roundNumber: r.roundNumber, hasScores: r.holeScores.length })));
            // console.log('Filtered Rounds:', item.roundScores.filter((roundScore: any) => roundScore.roundNumber <= currentRound).map((r: any) => r.roundNumber));
        }
        (item.roundScores ?? []).filter((roundScore) => roundScore.roundNumber <= currentRound).forEach((roundScore) => {
            let roundScoreToPar = 0;
            const validRound = roundScore.holeScores.every((holeScore) => holeScore.playerScore !== 0 && holeScore.playerScore !== null);
            // Get the courseID for this specific round
            const roundScoreCourseID = eventData?.rounds?.[roundScore.roundNumber - 1]?.courseID;
            const roundCourseData = (0, courseDataHelpers_1.getCourseById)(courseData, roundScoreCourseID);
            const teeSetData = (0, courseDataHelpers_1.getTeeSetFromCourse)(roundCourseData, item?.playerInfo?.[0]?.teeSet);
            if (item?.playerInfo?.[0]?.playerName.includes('Alex')) {
                // console.log('Player Name:', item?.playerInfo?.[0]?.playerName);
                // console.log('Round Number:', roundScore.roundNumber);
            }
            roundScore.holeScores.forEach((holeScore) => {
                if (holeScore.playerScore !== 0 && holeScore.playerScore !== null) {
                    roundScoreToPar += holeScore.playerScore - (leaderboardScoreFormat === 'net' ? holeScore.playerHcpAdj : 0) - (teeSetData?.holes?.[holeScore.holeNumber - 1]?.par || 0);
                }
            });
            if (item?.playerInfo?.[0]?.playerName.includes('Alex')) {
                // console.log('Valid Round:', validRound, 'Round Score To Par:', roundScoreToPar);
            }
            if (validRound) {
                if (item?.playerInfo?.[0]?.playerName.includes('Alex')) {
                    // console.log('Comparing:', roundScoreToPar, '<', playerBestRoundScore);
                }
                if (roundScoreToPar < playerBestRoundScore) {
                    if (item?.playerInfo?.[0]?.playerName.includes('Alex')) {
                        // console.log('NEW BEST ROUND! Previous:', playerBestRoundScore, 'New:', roundScoreToPar);
                    }
                    playerBestRoundScore = roundScoreToPar;
                    hasValidRound = true;
                }
            }
        });
        if (item?.playerInfo?.[0]?.playerName.includes('Alex')) {
            // console.log('Player Best Round Score:', playerBestRoundScore, 'Has Valid Round:', hasValidRound);
        }
        // Only add to total if player has at least one valid/completed round
        if (hasValidRound) {
            totalScoreToPar += playerBestRoundScore;
        }
        //console.log('Confirmed/Submitted:', item?.roundScores?.[currentRound - 1]?.confirmed, item?.roundScores?.[currentRound - 1]?.submitted);
        confirmed = item?.roundScores?.[currentRound - 1]?.confirmed ?
            (confirmed ? true : false) : false;
        submitted = item?.roundScores?.[currentRound - 1]?.submitted ?
            (submitted ? true : false) : false;
        holesCompleted = Math.min(holesCompleted, (item.roundScores ?? []).reduce((totalHoles, roundScore) => {
            //console.log('Total Holes / Holes Played:', totalHoles, roundScore.holeScores.filter((holeScore: any) => holeScore.playerScore !== 0 && holeScore.playerScore !== null).length);
            return totalHoles + roundScore.holeScores.filter((holeScore) => holeScore.playerScore !== 0 && holeScore.playerScore !== null).length;
        }, 0));
        //console.log('Holes Completed:', holesCompleted);
        eventScores.push(item);
        if (index === leaderboardData.length - 1 || item.teamName !== leaderboardData[index + 1].teamName) {
            //console.log('Holes Completed:', holesCompleted);
            return {
                _id: item._id,
                teamName: item.teamName,
                toPar: totalScoreToPar,
                eventScores: eventScores,
                holesCompleted: holesCompleted,
                confirmed: confirmed,
                submitted: submitted
            };
        }
    }).filter((item) => item !== undefined); // Ensure item is not undefined
    const adminRanks = Array.from(new Set(processedTeamsData.filter((item) => item.eventScores.some((score) => score.teamRank && score.teamRank > 0)).map((item) => item.eventScores.find((score) => score.teamRank && score.teamRank > 0).teamRank)));
    const sortedTeamsData = processedTeamsData
        .sort((a, b) => {
        // First, handle the case where one or both players have 0 holes completed
        if (a.holesCompleted === 0 && b.holesCompleted === 0) {
            return 0; // Both have 0 holes, keep original order
        }
        if (a.holesCompleted === 0) {
            return 1; // a has 0 holes, b has some - a goes after b
        }
        if (b.holesCompleted === 0) {
            return -1; // b has 0 holes, a has some - b goes after a
        }
        // Both players have completed holes, sort by toPar
        if (a.toPar !== b.toPar) {
            return a.toPar - b.toPar; // Lower score is better
        }
        // If toPar is the same, sort by holesCompleted (descending)
        return b.holesCompleted - a.holesCompleted;
    })
        .reduce((acc, item, index, array) => {
        // Find the maximum rank currently assigned in the accumulated array
        const maxExistingRank = index === 0 ?
            Math.max(...processedTeamsData.map((entry) => entry.teamRank || 0)) :
            acc.length > 0 ? Math.max(...acc.map((entry) => entry.teamRank || 0)) : 0;
        const existingTeamRank = item.eventScores?.find((score) => score.teamRank && score.teamRank > 0)?.teamRank;
        // Calculate the new rank based on sorting rules
        let calculatedRank;
        let calcRankComment;
        // If item already has a rank, keep it
        if (existingTeamRank && existingTeamRank > 0) {
            calculatedRank = existingTeamRank;
            calcRankComment = 'Keep existing rank';
        }
        // If item is a tie, keep the same rank
        else if (index > 0 &&
            ((item.holesCompleted > 0 && array[index - 1].holesCompleted > 0 &&
                item.toPar === array[index - 1].toPar /*&&
            item.holesCompleted === array[index - 1].holesCompleted */) ||
                (item.holesCompleted === 0 && array[index - 1].holesCompleted === 0))) {
            calculatedRank = acc[acc.length - 1].teamRank; // Same rank for ties
            calcRankComment = 'Same rank for ties';
        }
        // If item is not a tie, assign a new rank
        else {
            if (index + 1 < Math.min(...adminRanks)) {
                calculatedRank = index + 1;
            }
            else {
                calculatedRank = Math.max(maxExistingRank + 1, index + 1, adminRanks.length > 0 ? Math.max(...adminRanks) + 1 : 1);
            }
            calcRankComment = 'New rank after max existing rank';
        }
        //console.log('Calculated Rank:', calculatedRank, calcRankComment);
        //console.log('Max Existing Rank:', maxExistingRank);
        //console.log('Admin Ranks:', adminRanks);
        item.teamRank = calculatedRank;
        acc.push(item);
        return acc;
    }, [])
        .sort((a, b) => {
        // Sort by rank value first, then by holes completed (descending)
        if (a.teamRank !== b.teamRank) {
            return a.teamRank - b.teamRank;
        }
        return b.holesCompleted - a.holesCompleted;
    });
    //console.log('Sorted Teams Data:', sortedTeamsData);
    setLocalTeamsData(sortedTeamsData);
};
const functionMap = {
    'sumScores': TeamsSumScores,
    'worstScoresByHole': TeamsWorstScoresByHole,
    'bestScoresByHole': TeamsBestScoresByHole,
    'highLowByHole': TeamsHighLowByHole,
    'bestRound': TeamsBestRound
};
const TeamsLogic = (functionName, props) => {
    const functionToCall = functionMap[functionName];
    if (!functionToCall) {
        throw new Error(`Function ${functionName} not found`);
    }
    const { seriesPoints, setLocalTeamsData, eventData, currentRound, pointsRankMap } = props;
    const round = eventData?.rounds?.[currentRound - 1];
    const useSeriesForTeams = round?.pointSystem === 'Series' &&
        round?.useSeriesPointsForTeams &&
        seriesPoints;
    // Respect the event-level countingScores cap (same logic as TeamsSumScores).
    const countingScores = Number(eventData?.countingScores) || null;
    const resolvePointsRank = (score) => {
        const id = score._id?.toString();
        if (pointsRankMap && id && pointsRankMap[id] != null) {
            return pointsRankMap[id];
        }
        return score.rank ?? 0;
    };
    const wrappedSetLocalTeamsData = useSeriesForTeams
        ? (data) => {
            const annotated = data.map((team) => {
                const playerDetails = (team.eventScores ?? []).map((score) => {
                    const id = score._id?.toString() ?? '';
                    const pointsRank = resolvePointsRank(score);
                    const points = (0, seriesPointsUtils_1.resolveSeriesPoints)(pointsRank, score.playerInfo?.[0]?.division ?? null, seriesPoints);
                    return {
                        id,
                        name: score.playerName,
                        division: score.playerInfo?.[0]?.division ?? '',
                        flight: score.playerInfo?.[0]?.flight ?? '',
                        scoreRank: score.rank ?? 0,
                        pointsRank,
                        adminRank: score.adminRank ?? 0,
                        points,
                    };
                });
                const sortedByPoints = [...playerDetails].sort((a, b) => b.points - a.points);
                const countedIds = new Set(sortedByPoints
                    .slice(0, countingScores ?? playerDetails.length)
                    .map((p) => p.id));
                const countedDetails = playerDetails.map((p) => ({
                    ...p,
                    counted: countedIds.has(p.id),
                }));
                const seriesPointsEarned = countedDetails
                    .filter((p) => p.counted)
                    .reduce((sum, p) => sum + p.points, 0);
                (0, seriesPointsDebug_1.logSeriesPoints)('teamRollup', {
                    teamName: team.teamName,
                    seriesPointsEarned,
                    players: countedDetails,
                });
                return { ...team, seriesPointsEarned };
            });
            // Sort descending by seriesPointsEarned (more points = better rank)
            const sorted = [...annotated].sort((a, b) => {
                if (b.seriesPointsEarned !== a.seriesPointsEarned) {
                    return b.seriesPointsEarned - a.seriesPointsEarned;
                }
                // Tiebreak: more holes completed first
                return b.holesCompleted - a.holesCompleted;
            });
            // Assign teamRank with proper tie handling
            let rankCounter = 1;
            const reranked = sorted.map((team, idx) => {
                if (idx > 0 && team.seriesPointsEarned !== sorted[idx - 1].seriesPointsEarned) {
                    rankCounter = idx + 1;
                }
                return { ...team, teamRank: rankCounter };
            });
            setLocalTeamsData(reranked);
        }
        : setLocalTeamsData;
    return functionToCall({ ...props, setLocalTeamsData: wrappedSetLocalTeamsData });
};
exports.TeamsLogic = TeamsLogic;
